import styles from './styles.module.scss';

export const NotFound: React.FC = () => (
  <div className={styles.Root}>
    <h1>404</h1>
    <p>ページが見つかりません</p>
  </div>
);
